import io from 'socket.io-client';
import store from '../../store/store'

let baseUrl = 'wss://';
// if(process.env.NODE_ENV === 'production') {
  baseUrl = 'wss://arstream.vitech.dev'
// }

if(process.env.VUE_APP_SOCKET_URL) {
  baseUrl = process.env.VUE_APP_SOCKET_URL
}

let socket = null;

const initializeSocket = () => {
  if (socket && socket.connected) {
    return
  }
  socket = io(baseUrl, {
    transports: ['websocket'],
    query: {
      authorization: store.state.auth.token
    },
  });
  socket.on('HELLO_WORLD', msg => {

  });

  socket.on('CALL_STATUS', ({callSid, status}) => {
    store.dispatch('call/updateCallStatus', {callSid, status})
  });

  socket.on('UPDATE_CONTACT', (contact) => {
    store.dispatch('contacts/updateContact', contact)
  });

  socket.on('CALL_STARTED', (call) => {
    store.commit('sessions/addCallInProgress', call)
  });

  socket.on('CALL_ENDED', (call) => {
    store.commit('sessions/removeCallInProgress', call)
  });

  socket.on('COMPOSITION_UPDATE', (session) => {
    store.commit('sessions/updateCompositionInfo', session)
  });

};

const subscripbeForTimeslice = (cb) => {
  socket.on('START_TIMESLICE', cb);
};

const disconnectSocket = () => {
  try {
    socket.disconnect();
  } catch (e) {}
};

export {
  initializeSocket,
  disconnectSocket,
  subscripbeForTimeslice
}
